import {
  HOLIDAY_GREEN,
  MATERNITY_LEAVE_BLUE,
  MILITARY_REHEARSAL_BROWN,
  SICK_LEAVE_RED,
  STUDY_LEAVE_YELLOW,
} from './constants';

export const hashCode = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};

export const intToRGB = (i: number): string => {
  let c = `#${(i & 0x00ffffff).toString(16).toUpperCase()}`;
  c = '00000'.substring(0, 6 - c.length) + c;

  // Check if the color is white or a variation of white
  if (
    c === '#FFFFFF' ||
    c === '#FFF' ||
    c === '#FFFFF0' ||
    c === '#F8F8FF' ||
    c === '#FFFAFA'
  ) {
    c = `#${((i + 1) & 0x00ffffff).toString(16).toUpperCase()}`;
    c = '00000'.substring(0, 6 - c.length) + c;
  }

  return c;
};

export const selectAbsenceColor = (code: string, name: string): string => {
  const colorMap: { [x: string]: string } = {
    HOLIDAY: HOLIDAY_GREEN,
    MILITARY_REHEARSAL: MILITARY_REHEARSAL_BROWN,
    SICK_LEAVE: SICK_LEAVE_RED,
    MATERNITY_LEAVE: MATERNITY_LEAVE_BLUE,
    STUDY_LEAVE: STUDY_LEAVE_YELLOW,
    VACATION: HOLIDAY_GREEN,
    OTHER: SICK_LEAVE_RED,
  };
  const color = colorMap[code];

  return color || intToRGB(hashCode(name) + hashCode(code));
};
